import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import blue from '@material-ui/core/colors/blue';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Picker from "./Picker";
import moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import {ValidatorForm} from "react-material-ui-form-validator";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import ImgMediaCard from "./ImgMediaCard";

const styles = {
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    textField: {
        marginLeft: 20,
    },
    textFieldAnswer: {
        marginLeft: 0,
    },
    fieldset: {
        width: "100%",
    },
    hide: {
        display: "none",
    },
    wrapper: {
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
};

class SelectDialog extends React.Component {
    handleClose = () => {
        this.props.onClose(null);
    };

    handleListItemClick = value => {
        this.props.onClose(value);
    };

    render() {
        const { handleSearch, search, fullScreen, classes, onClose, surveysTemplates, ...other } = this.props;

        return (
            <Dialog fullScreen={fullScreen} onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
                <DialogTitle id="simple-dialog-title">
                    Choisir un point de contrôle
                    <TextField
                        id="standard-search"
                        label="Rechercher..."
                        type="search"
                        onChange={handleSearch}
                        className={classes.textField}
                        margin="normal"
                    />
                </DialogTitle>
                <DialogContent>
                    <List>
                        {surveysTemplates.filter(t => (search === "" || t.title.toLowerCase().includes(search.toLowerCase()))).map(template => (
                            <ListItem button onClick={() => this.handleListItemClick(template.id)} key={template.id}>
                                <ListItemText primary={template.title} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary" autoFocus>
                        Fermer
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

SelectDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    selectedValue: PropTypes.string,
};

const SelectDialogWrapped = withStyles(styles)(SelectDialog);

class SurveyDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            survey: null,
            loaded: false,
        };
    }

    handleClose = () => {
        this.props.onClose(null);
    };

    handleListItemClick = value => {
        this.props.onClose(value);
    };

    componentWillReceiveProps(nextProps) {
        if(nextProps.survey && "queries" in nextProps.survey && nextProps.survey !== this.state.survey){
            const survey = nextProps.survey;
            /* Remplissage des valeurs par default */
            for(var i = 0; i < survey.queries.length; i ++){
                var query = survey.queries[i];
                for(var j = 0; j < query.answers.length; j ++){
                    var answer = query.answers[j];
                    if(answer.type === "string" && answer.answer && answer.answer !== ""){
                        answer.answer= this.tagToString(answer.answer)
                    }
                }

            }
            this.setState({
                survey: survey,
                loaded: true,
            });
        }
    }

    tagToString(str){
        const report = this.props.report;
        const user = this.props.user;
        str = str.replace(/#company_ref/g, report.audit.company.reference);
        str = str.replace(/#company_name/g, report.audit.company.name);

        str = str.replace(/#user_realname/g, (user.firstname + " " + user.surname));

        str = str.replace(/#audit_ref/g, report.audit.reference);


        str = str.replace(/#audit_qualif/g, report.audit.qualifications.map(q => (
            q.reference
        )).join(', '));
        str = str.replace(/#audit_mention/g, report.audit.mentions.map(q => (
            q.reference
        )).join(', '));

        return str

    }

    handleChange = (event, id) => {
        const { survey } = this.state;
        var query = survey.queries.find(q => q.id === id)
        query.answers.map(a =>{
            switch(a.type){
                case 'check':
                    if( a.id.toString() === event.target.value){
                        a.status = 1;
                    }else{
                        a.status = 0;
                    }
                    break;
                case 'string':
                    // if(event.target.name === "qualifications"){
                    //     a.answer = "#audit_qualif" + this.props.listOfQualifications.filter(q => event.target.value.includes(q.id)).map(q => (
                    //         q.reference + " - " + q.name.replace(/ +(?= )/g,'')
                    //     )).join('\n')
                    // }else if(event.target.name === "mentions"){
                    //     a.answer = "#audit_mention" + this.props.listOfMentions.filter(q => event.target.value.includes(q.id)).map(q => (
                    //         q.reference + " - " + q.name.replace(/ +(?= )/g,'')
                    //     )).join('\n')
                    // }else{
                        a.answer = event.target.value
                    //}

                    break;
                case 'date':
                    a.answer = event
                    break;
                default:
                    break;
            }
            return a;
        })
        this.setState({ survey });
    };

    handleFormSubmit(){
        //
    }

    render() {
        const { edit, handleSubmit, listOfQualifications, listOfMentions, loading, survey, fullScreen, classes, onClose, surveysTemplates, ...other } = this.props;
        const _this = this;
        return (
            <Dialog fullScreen={fullScreen} onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
                <DialogTitle id="simple-dialog-title">
                    {this.state.survey ? this.state.survey.title : ""}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                    {((loading && !edit) || !this.state.survey) ? (
                        <CircularProgress className={classes.progress} />
                    ) : (
                        this.state.survey.queries.map(q => {
                            return (
                                <Grid key={q.id} item xs={12}>
                                    <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
                                        <ValidatorForm onSubmit={this.handleFormSubmit}>
                                        <FormLabel component="legend">{q.query}</FormLabel>
                                        {(function() {
                                            switch(q.answers[0].type) {
                                                case 'check':
                                                    var selected = q.answers.find(q => q.status === 1)
                                                    return (
                                                        <RadioGroup
                                                            aria-label="position"
                                                            name="position"
                                                            value={selected ? selected.id.toString() : ""}
                                                            onChange={(e) => _this.handleChange(e, q.id)}
                                                            row
                                                        >
                                                            {q.answers.filter(a => a.type === "check").map(a => {
                                                                return (
                                                                    <FormControlLabel
                                                                        key={a.id}
                                                                        value={a.id.toString()}
                                                                        control={<Radio color="primary" />}
                                                                        label={a.label}
                                                                        labelPlacement="end"
                                                                    />
                                                                )
                                                            })}
                                                        </RadioGroup>
                                                    )
                                                case 'string':
                                                    // if(q.answers[0].answer && q.answers[0].answer.includes("#audit_qualif")){
                                                    //     return (
                                                    //         <div>
                                                    //             <SearchSelect
                                                    //                 name="qualifications"
                                                    //                 placeholder="Liste des qualification(s)"
                                                    //                 defaultValue={_this.props.report.audit.qualifications}
                                                    //                 options={listOfQualifications}
                                                    //                 handleInputChange={(e) => _this.handleChange(e, q.id)}
                                                    //             />
                                                    //             <TextField
                                                    //                 multiline
                                                    //                 fullWidth
                                                    //                 type="text"
                                                    //                 value={q.answers[0].answer ? q.answers[0].answer : ""}
                                                    //                 className={classes.hide}
                                                    //                 margin="normal"
                                                    //             />
                                                    //         </div>
                                                    //     )
                                                    // }else if(q.answers[0].answer && q.answers[0].answer.includes("#audit_mention")){
                                                    //     return (
                                                    //         <div>
                                                    //             <SearchSelect
                                                    //                 name="mentions"
                                                    //                 placeholder="Liste des mention(s)"
                                                    //                 defaultValue={_this.props.report.audit.mentions}
                                                    //                 options={listOfMentions}
                                                    //                 handleInputChange={(e) => _this.handleChange(e, q.id)}
                                                    //             />
                                                    //             <TextField
                                                    //                 multiline
                                                    //                 fullWidth
                                                    //                 type="text"
                                                    //                 value={q.answers[0].answer ? q.answers[0].answer : ""}
                                                    //                 className={classes.hide}
                                                    //                 margin="normal"
                                                    //             />
                                                    //         </div>
                                                    //     )
                                                    // }else {
                                                        return (
                                                            <TextField
                                                                multiline
                                                                fullWidth
                                                                type="text"
                                                                value={q.answers[0].answer ? q.answers[0].answer : ""}
                                                                onChange={(e) => _this.handleChange(e, q.id)}
                                                                className={classes.textFieldAnswer}
                                                                margin="normal"
                                                            />
                                                        )
                                                    //}
                                                case 'date':
                                                    return (
                                                        <Picker
                                                            onChange={(e) => _this.handleChange(e, q.id)}
                                                            name={q.id.toString()}
                                                            value={q.answers[0].answer ? q.answers[0].answer : (_this.props.report ? _this.props.report.audit.date : new Date())}
                                                            format="DD/MM/YYYY HH:mm"
                                                        />
                                                    )
                                                case 'document':
                                                    var path = "";
                                                    if(q.answers[0].answer.includes("#stamp") && _this.props.user.stamp){
                                                        path = _this.props.user.stamp.path
                                                    } else if(q.answers[0].answer.includes("#signature") && _this.props.user.signature){
                                                        path = _this.props.user.signature.path
                                                    } else if(q.answers[0].answer.includes("#logo") && _this.props.user.logo){
                                                        path = _this.props.user.logo.path
                                                    }

                                                    return (
                                                        <ImgMediaCard
                                                            title={q.query}
                                                            image={path}
                                                            hideButtons={true}
                                                        />
                                                    )
                                                default:
                                                    return null;
                                            }
                                        })()}
                                        </ValidatorForm>
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            )
                        })
                    )}
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        Annuler
                    </Button>
                    <div className={classes.wrapper}>
                        <Button
                            variant="contained"
                            autoFocus
                            color="primary"
                            disabled={this.props.loading}
                            onClick={() => handleSubmit(this.state.survey)}
                        >
                            {this.props.edit ? "Modifier" : "Valider"}
                        </Button>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

SurveyDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    selectedValue: PropTypes.string,
};

const SurveyDialogWrapped = withStyles(styles)(SurveyDialog);

class FormDialog extends React.Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            openSurvey: false,
            openSelect: false,
            search: "",
            selectedValue: null,
            loading: false,
        };
    }



    handleSubmit(survey){
        const _this = this;
        /* Supprime les tags superflus #audit_mention et/ou #audit_qualif*/
        // var queries = survey.queries;
        // for(var i =0; i < queries.length; i++){
        //     var answers = queries[i].answers;
        //     for(var j =0; j < answers.length; j++){
        //         var answer = answers[j].answer;
        //         if(answer && answer !== "#audit_qualif" && answer.includes("#audit_qualif")){
        //             answer = answer.replace("#audit_qualif", "")
        //         }
        //         if(answer && answer !== "#audit_mention" && answer.includes("#audit_mention")){
        //             //survey.queries[i].answers[j].answer = answer.replace("#audit_mention", "")
        //             console.log(survey.queries[i].answers[j].answer)
        //         }
        //     }
        // }

        if(this.props.edit){
            this.setState({ loading: true }, ()=> {
                this.props.updateSurveyCopyAction(survey.id, this.props.report.id, survey)
                    .then(res => {
                        if (_this.props.handleClickClose) {
                            _this.props.handleClickClose()
                        }
                        this.setState({openSurvey: false, openSelect: false, loading: false}, () => {
                            /* import le rapport */
                            //_this.props.getReportByIdAction(_this.props.report.id, _this.props.reports, true)
                        });
                    })
                    .catch(err => {
                        if (_this.props.handleClickClose) {
                            _this.props.handleClickClose()
                        }
                        this.setState({openSurvey: false, openSelect: false, loading: false});
                    })
            });
        }else{
            this.setState({ loading: true }, ()=> {
                this.props.createCopySurveyAction(survey.id, this.props.report.id, survey)
                    .then(res => {
                        if(_this.props.handleClickClose){
                            _this.props.handleClickClose()
                        }
                        this.setState({ openSurvey: false, openSelect: false, loading: false }, ()=>{
                            /* import le rapport */
                            //_this.props.getReportByIdAction(_this.props.report.id, _this.props.reports, true)
                        });
                    })
                    .catch(err=> {
                        if(_this.props.handleClickClose){
                            _this.props.handleClickClose()
                        }
                        this.setState({ openSurvey: false, openSelect: false, loading: false });
                    })
            });
        }

    }


    componentWillReceiveProps(nextProps) {
        if(nextProps.survey && !this.state.selectedValue){
            this.props.getSurveyByIdAction(nextProps.survey.id).then(res => {
                this.setState({ loading: false, selectedValue: res, openSurvey: true, openSelect: false });
            })
        }else if(!nextProps.survey && this.state.selectedValue){
            this.setState({ selectedValue: null, openSurvey: false, openSelect: false });
            if(this.props.handleClickClose){
                this.props.handleClickClose()
            }
        }
    }

    componentWillMount() {
        /* import les formulaires */
        this.props.getSurveysTemplatesAction()
        /* import les qualifications */
        this.props.getQualificationsAction()
        /* import les mentions */
        this.props.getMentionsAction()
    }

    handleClickOpenSurvey = () => {
        this.setState({
            openSurvey: true,
        });
    };

    handleCloseSurvey = () => {
        if(this.props.handleClickClose){
            this.props.handleClickClose()
        }
        this.setState({ openSurvey: false, selectedValue: null });
    };

    handleClickOpenSelect = () => {
        this.setState({
            openSelect: true,
        });
    };

    handleCloseSelect = value => {
        this.setState({ openSurvey: (value ? true : false),openSelect: false, loading: (value ? true: false), search: "" }, () => {
            if(value){
                this.props.getSurveyByIdAction(value).then(res => {
                    this.setState({ loading: false, selectedValue: res });
                })
            }
        });
    };

    handleSearch = e => {
       this.setState({ search: e.target.value });
    };

    render() {
        return (
            <div>
                {!this.props.hideButton && (
                    <Button variant="outlined" onClick={this.handleClickOpenSelect}>
                        Ajouter un point de contrôle
                    </Button>
                )}
                <SelectDialogWrapped
                    handleSearch={this.handleSearch}
                    search={this.state.search}
                    fullScreen={this.props.fullScreen}
                    surveysTemplates={this.props.surveysTemplates}
                    open={this.state.openSelect}
                    onClose={this.handleCloseSelect}
                />
                <SurveyDialogWrapped
                    handleSubmit={this.handleSubmit}
                    listOfQualifications={this.props.listOfQualifications}
                    listOfMentions={this.props.listOfMentions}
                    user={this.props.user}
                    report={this.props.report}
                    loading={this.state.loading}
                    survey={this.state.selectedValue}
                    fullScreen={this.props.fullScreen}
                    surveysTemplates={this.props.surveysTemplates}
                    open={this.state.openSurvey}
                    onClose={this.handleCloseSurvey}
                    edit={this.props.edit}
                />
            </div>
        );
    }
}

const mapStateToProps=(state)=>{
    return state
};

FormDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default connect (mapStateToProps, actionCreators)(withMobileDialog()(FormDialog));


// WEBPACK FOOTER //
// ./src/component/utils/FormDialog.js